import { Component, Input } from '@angular/core';
import { OrderHistoryEvent } from '../../../models-otc/order-history-event.model';

@Component({
    selector: 'app-order-history-event-detail',
    templateUrl: './order-history-event-detail.component.html',
    styleUrls: ['./order-history-event-detail.component.css'],
    standalone: false
})
export class OrderHistoryEventDetailComponent {
    @Input() event: OrderHistoryEvent;

    get detailStrategy(): string {
        switch (this.event?.eventType) {
            case 'ORDER_CREATED':
            case 'ORDER_COPIED':
                return 'order-created';
            case 'ORDER_UPDATED':
            case 'ORDER_STATUS_CHANGED':
            case 'PAYMENT_TERMS_CHANGED':
            case 'ORDER_UPDATED_POST_SAP':
                return 'field-diff';
            case 'ORDER_DELETED':
                return 'order-deleted';
            case 'ITEM_ADDED':
                return 'item-card';
            case 'ITEM_UPDATED':
                return 'item-diff';
            case 'ITEM_DELETED':
                return 'item-deleted';
            case 'NOTE_ADDED':
                return 'note-added';
            case 'NOTE_UPDATED':
                return 'note-diff';
            case 'SAP_SUBMISSION_FAILED':
                return 'sap-error';
            default:
                return 'none';
        }
    }

    get changedFields(): { field: string; oldVal: any; newVal: any }[] {
        if (!this.event?.oldValue || !this.event?.newValue) return [];
        return Object.keys(this.event.newValue)
            .filter(key =>
                JSON.stringify(this.event.oldValue[key]) !==
                JSON.stringify(this.event.newValue[key])
            )
            .map(key => ({
                field: this.formatFieldLabel(key),
                oldVal: this.event.oldValue[key],
                newVal: this.event.newValue[key]
            }));
    }

    get newValueEntries(): { field: string; value: any }[] {
        if (!this.event?.newValue) return [];
        return Object.keys(this.event.newValue).map(key => ({
            field: this.formatFieldLabel(key),
            value: this.event.newValue[key]
        }));
    }

    get oldValueEntries(): { field: string; value: any }[] {
        if (!this.event?.oldValue) return [];
        return Object.keys(this.event.oldValue).map(key => ({
            field: this.formatFieldLabel(key),
            value: this.event.oldValue[key]
        }));
    }

    formatFieldLabel(key: string): string {
        return key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, s => s.toUpperCase())
            .trim();
    }
}
